import angular from 'angular';

customPopoverDirective.$inject = ['$templateCache', '$http', '$q', '$compile'];
export default function customPopoverDirective($templateCache, $http, $q, $compile) {
    return {
        restrict: 'A',
        scope: {
            titulo: '@',
            template: '@',
            templateUrl: '@',
            onAction: '&'
        },
        link: function (scope, el, attrs) {
            var popover = null;
            $(el).click(function () {
                if (typeof scope.templateUrl != 'undefined') {
                    loadTemplate(scope.template).then(
                        function (dialogTemplate) {
                            var templateCompilado = $compile(dialogTemplate)(scope);
                            popover = crearYAbrirPopover(templateCompilado, scope);
                        }
                    );
                } else {
                    var templateCompilado = $compile(scope.template)(scope);
                    popover = crearYAbrirPopover(templateCompilado, scope)
                }
                setTimeout(function () {
                    popover.webuiPopover('show');
                }, 200);
            });

            function crearYAbrirPopover(templateCompilado, scope) {
                scope.callback = function () {
                    console.log('Dentro del callback!');
                    scope.onAction();
                };
                var popoverDentro = $(el).webuiPopover({
                    title: scope.titulo,
                    trigger: 'manual',
                    content: function () {
                        return templateCompilado;
                    },
                    closeable: true,
                    maxHeight: "400px",
                    onHide: function ($element) {
                        popoverDentro.webuiPopover('destroy');
                    }
                });
                setTimeout(function () {
                    popoverDentro.webuiPopover('show');
                }, 200);
                return popoverDentro;
            }

            //TODO: Están repetidas en dialogService
            function loadTemplate(template) {
                var deferred = $q.defer();
                var html = $templateCache.get(template);

                if (angular.isDefined(html)) {
                    // The template was cached or a script so return it
                    html = trim(html);
                    deferred.resolve(html);
                } else {
                    // Retrieve the template if it is a URL
                    return $http.get(template, {cache: $templateCache}).then(
                        function (response) {
                            var html = response.data;
                            if (!html || !html.length) {
                                // Nothing was found so reject the promise
                                return $q.reject("Template " + template + " was not found");
                            }
                            html = trim(html);
                            // Add it to the template cache using the url as the key
                            $templateCache.put(template, html);
                            return html;
                        }, function () {
                            return $q.reject("Template " + template + " was not found");
                        }
                    );
                }
                return deferred.promise;
            }

            function trim(string) {
                return string ? string.replace(/^\s+|\s+$/g, '') : string;
            }
        }

    };
}